import { useEffect, useState } from "react";

const slides = [
  {
    title: "Sevinç Outdoor seçimleri",
    subtitle: "Kamp, mutfak ve profesyonel kullanım için özenle seçilen ekipmanları keşfet.",
    tag: "Outdoor Koleksiyon",
    video: "/slider-video-1.mp4",
    cta: "Koleksiyonu İncele",
  },
  {
    title: "Doğaya hazır ekipmanlar",
    subtitle: "Dayanıklı, pratik ve uzun kullanıma uygun ürünlerle her plana hazır ol.",
    tag: "Kamp & Outdoor",
    video: "/slider-video-2.mp4",
    cta: "Ürünleri Keşfet",
  },
  {
    title: "Profesyonel kullanıma uygun",
    subtitle: "Mutfaktan araziye, ihtiyacına göre filtrele ve doğru ürüne hızlı ulaş.",
    tag: "Premium Seri",
    video: "/slider-video-3.mp4",
    cta: "Avantajları Gör",
  },
];

export default function Slider() {
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % slides.length), 3000);
    return () => clearInterval(t);
  }, []);

  const s = slides[i];

  return (
    <section className="reveal px-0 py-4 sm:px-4 sm:py-5 md:px-5 lg:px-10">
      <div className="relative min-h-[360px] overflow-hidden bg-stone-950 shadow-soft sm:min-h-[390px] sm:rounded-2xl md:rounded-[2rem] lg:min-h-[520px]">
        <video
          key={`${s.video}-${i}`}
          className="absolute inset-0 h-full w-full object-cover opacity-75"
          src={s.video}
          autoPlay
          muted
          playsInline
          preload="metadata"
        />

        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/55 to-black/5" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent" />

        <div className="relative z-10 flex min-h-[360px] items-center p-5 text-white sm:min-h-[390px] sm:p-12 lg:min-h-[520px] lg:p-16">
          <div className="max-w-2xl">
            <span className="text-xs uppercase text-amber-100 sm:text-sm">{s.tag}</span>
            <h1 className="mb-4 mt-4 text-3xl font-extrabold leading-tight sm:mb-5 sm:mt-5 sm:text-5xl lg:text-6xl">
              {s.title}
            </h1>
            <p className="max-w-xl text-sm leading-7 text-stone-100 sm:text-xl sm:leading-8">
              {s.subtitle}
            </p>
            <a
              href="/register"
              className="mt-8 inline-flex border border-white/80 px-6 py-3 text-sm font-bold transition hover:bg-white hover:text-stone-950"
            >
              {s.cta}
            </a>
          </div>
        </div>

        <div className="absolute bottom-5 left-0 right-0 z-20 flex justify-center gap-2">
          {slides.map((_, idx) => (
            <button
              aria-label={`Slayt ${idx + 1}`}
              key={idx}
              onClick={() => setI(idx)}
              className={`h-2.5 w-2.5 rounded-full ${idx === i ? "bg-white" : "bg-white/45"}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
